import { collection, getDocs } from 'firebase/firestore';
import { db } from '../firebase/config';
import { createNotification } from './notificationService';
// import { sendNewPostEmail } from './emailService'; // Deshabilitado temporalmente

/**
 * Envía notificaciones a todos los seguidores cuando un usuario crea un nuevo post
 * @param userId ID del usuario que creó el post
 * @param postId ID del post creado
 * @param postContent Contenido del post
 * @param userName Nombre del usuario que creó el post
 * @param userPhotoURL URL de la foto del usuario que creó el post
 * @returns Promise<{success: number, failed: number}> Número de notificaciones enviadas con éxito y fallidas
 */
export const notifyFollowersAboutNewPost = async (
  userId: string,
  postId: string,
  // postContent: string, // No se usa sin email
  userName: string,
  userPhotoURL: string
): Promise<{ success: number, failed: number }> => {
  try {
    // Obtener todos los seguidores del usuario
    const followersRef = collection(db, `users/${userId}/followers`);
    const followersSnapshot = await getDocs(followersRef);

    if (followersSnapshot.empty) {
      console.log(`El usuario ${userId} no tiene seguidores para notificar.`);
      return { success: 0, failed: 0 };
    }

    let successCount = 0;
    let failedCount = 0;

    // Para cada seguidor, crear una notificación y enviar un correo
    const notificationPromises = followersSnapshot.docs.map(async (followerDoc) => {
      try {
        const followerId = followerDoc.id;


        // Crear notificación en la app
        await createNotification({
          type: 'post',
          fromUserId: userId,
          fromUserName: userName,
          fromUserPhoto: userPhotoURL,
          toUserId: followerId,
          postId: postId,
          read: false
        });



        successCount++;
      } catch (error) {
        console.error(`Error al notificar al seguidor ${followerDoc.id}:`, error);
        failedCount++;
      }
    });

    await Promise.all(notificationPromises);

    console.log(`Notificaciones enviadas: ${successCount} exitosas, ${failedCount} fallidas`);
    return { success: successCount, failed: failedCount };
  } catch (error) {
    console.error('Error al notificar a los seguidores:', error);
    throw new Error('No se pudieron enviar las notificaciones a los seguidores');
  }
};
